import { Button } from 'components/common/button/Button';
import { observer } from 'mobx-react';
import moment from 'moment';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { DATE_FORMAT_SHORTER } from '../../../config';
import { filesContext } from '../../../state/filesState';
import { GenericSorter } from '../../../state/genericSorter';
import { Spinner } from '../../common/spinner/Spinner';
import { SortHeaderCell } from '../../common/table/SortHeaderCell';
import { useOnKeySelect } from 'utils/hooks';

export const Letters = observer(() => {
  const filesState = useContext(filesContext);
  const [sorter, updateSorter] = useState(
    new GenericSorter(filesState.letters, 'letterDate', false)
  );
  const [tableFocused, setTableFocused] = useState(false);
  const tableRef = useRef<HTMLTableElement>(null);
  const rowRefs = useRef<HTMLTableRowElement[]>([]);

  useOnKeySelect(tableFocused, tableRef, 'tr.letter-row');

  const viewLetter = () => {
    filesState.printLetter();
  };

  const handleBlur = (e: React.FocusEvent) => {
    if (!rowRefs.current?.includes(e.relatedTarget as any)) {
      setTableFocused(false);
    }
  }

  const handleFocus = (e: React.FocusEvent) => {
    if (rowRefs.current?.includes(e.target as any)) {
      setTableFocused(true);
    }
  }

  useEffect(() => {
    const newSorter = new GenericSorter(
      filesState.letters,
      'letterDate',
      false
    );
    updateSorter(newSorter);
  }, [filesState.letters]);

  return (
    <div className='letters'>
      <h2 id='lettersLabel'>Outgoing letters</h2>

      <div className='letters-table-wrapper'>
        <table
          aria-labelledby='lettersLabel'
          className='table letters-table'
          ref={tableRef}
        >
          <thead>
            <tr>
              <SortHeaderCell
                sorter={sorter}
                type='letterDate'
                text='Date'
                className='letter-cell-date'
                mode='td'
              />
              <SortHeaderCell
                sorter={sorter}
                type='channelUsed'
                text='Channel'
                className='letter-cell-channel'
                mode='td'
              />
              <SortHeaderCell
                sorter={sorter}
                type='letterType'
                text='Type'
                className='letter-cell-type'
                mode='td'
              />
            </tr>
          </thead>
          <tbody>
            {sorter.sortedEntries.map((letter, index) => {
              return (
                <tr
                  className={
                    'letter-row ' +
                    (letter === filesState.selectedLetter ? 'selected' : '')
                  }
                  key={letter.id + index}
                  onClick={() => filesState.selectLetter(letter)}
                  aria-selected={letter === filesState.selectedLetter}
                  tabIndex={(index == 0 && filesState.selectedLetter == null) || (letter === filesState.selectedLetter) ? 0 : -1}
                  ref={(el) => (rowRefs.current[index] = el as HTMLTableRowElement)}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                >
                  <td className='letter-cell-date'>
                    {letter.sentDate
                      ? moment(letter.sentDate).format(DATE_FORMAT_SHORTER)
                      : 'Unknown'}
                  </td>
                  <td className='letter-cell-channel'>
                    {letter.channelUsed}
                  </td>
                  <td className='letter-cell-type'>
                    {letter.letterType && letter.letterType.name}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {filesState.loadingLetters ? <Spinner blocking /> : null}
      </div>
      <Button
        disabled={filesState.selectedLetter === null}
        onClick={viewLetter}
        loading={filesState.downloadingLetter}
      >
        View
      </Button>
    </div>
  );
});